import React from "react";
import { Link } from "react-router-dom";
import { useSidebar } from "@/contexts/SidebarContext";
import { MenuIcon } from "@/components/Icons/MenuIcon";
import { NotificationIcon } from "@/components/Icons/NotificationIcon";
import LogoMark from "@/assets/images/logos/LogoMark.svg";
import DSXRLogo from "@/assets/images/logos/DS_XR.svg";
import { AdminHeaderPopover } from "./AdminHeaderPopover";
import { LanguageSelector } from "../Tenant/LanguageSelector";

/** Logo section component for admin header */
const LogoSection: React.FC = () => (
  <div className="hidden lg:flex items-center gap-3">
    <img src={LogoMark} alt="LogoMark" className="h-6" />
    <div className="h-6 w-px bg-white/20" />
    <span className="font-medium text-lg leading-none text-ds-accent">
      DS Admin
    </span>
    <div className="h-6 w-px bg-white/20" />
    <img src={DSXRLogo} alt="DS_XR" className="h-5" />
  </div>
);

export const AdminHeader: React.FC = () => {
  const { toggleMobileSidebar } = useSidebar();

  return (
    <header
      className="fixed top-0 left-0 right-0 h-16 border-b border-white/10 z-50 transition-all duration-300 flex items-center justify-between px-6"
      style={{ backgroundColor: "#161C29" }}
    >
      {/* Sol taraf */}
      <div className="flex items-center gap-4">
        <button
          onClick={toggleMobileSidebar}
          className="lg:hidden p-2 text-white hover:bg-white/10 rounded-lg transition-colors"
          aria-label="Toggle sidebar"
        >
          <MenuIcon />
        </button>

        <Link to="/admin" className="flex items-center">
          <LogoSection />
        </Link>
      </div>

      {/* Sağ taraf */}
      <div className="flex items-center gap-2 lg:gap-4">
        {/* Language Selector - Visible on all screen sizes */}
        <LanguageSelector />

        <div className="h-[30px] w-px bg-white/20" />

        <AdminHeaderPopover />
      </div>
    </header>
  );
};
